<aside class="prepend-action big-input-grid-with">
  <h4 class="to"><span>with</span></h4>
  <div id="prepend-container" [ngClass]="'grid-2'">
    <label [ngSwitch]="this.destinationTypeControl.value" class="other-operators">
      <input *ngSwitchCase="'STRING'" type="text" [formControl]="valueControl" placeholder="Enter a value...">
      <input *ngSwitchDefault type="text" disabled placeholder="No field selected">
    </label>
    <span class="material-icons notranslate tooltip-icon danger"
          matTooltip="{{truncWarningToolTip}}"
          matTooltipClass="mat-tooltip">error_outline</span>
  </div>
</aside>
